var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('inspect-mooring-line',{attrs:{"value":_vm.value,"qa":_vm.qa,"report":_vm.report,"lite":true},on:{"updateValue":_vm.updateValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }